import { render, staticRenderFns } from "./second-stuff.vue?vue&type=template&id=37c4263d&scoped=true&"
import script from "./second-stuff.vue?vue&type=script&lang=js&"
export * from "./second-stuff.vue?vue&type=script&lang=js&"
import style0 from "./second-stuff.vue?vue&type=style&index=0&id=37c4263d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c4263d",
  null
  
)

export default component.exports